<template>
<el-container style="min-height: 100%;">
    <el-main style="background-color: #fff;">
        <div class="_flex">
            <el-input placeholder="姓名" v-model="adminSearch.nick_name" clearable size="small" style="width: 200px;"/>
			<el-input placeholder="手机号码" v-model="adminSearch.phone" clearable size="small" style="width: 200px;margin-left: 10px;"/>
            <el-select v-model="adminSearch.state" clearable size="small" placeholder="状态" style="width: 150px;margin-left: 10px;">
                <el-option label="正常" value="1"></el-option>
                <el-option label="禁用" value="2"></el-option>
            </el-select>
            <el-button size="small" style="margin-left: 10px;" @click="getAdminLists(1)">筛选</el-button>
			<el-button size="small" type="success" v-permit="'/admin/department/add'"  @click="departAdd({}, '创建部门')">创建部门</el-button>
			<el-button size="small" type="warning" v-permit="'/admin/role/lists'" @click="$router.push('/permissionRole')">职务角色</el-button>
			<el-button size="small" type="primary" v-permit="'/admin/admin/add'" @click="handleAdminAdd">添加成员</el-button>
		</div>
		<div class="_flex_sb mt_20">
			<div class="left bag_f5 p_10 br_8" style="width: 200px;">
                <el-scrollbar style="height: 70vh;">
                <el-tree :data="deparToptArr" :props="defaultProps" node-key="id" :default-expand-all="false" :default-expanded-keys="defaultExpandedKeys" :expand-on-click-node="false" @node-click="selectDepart" highlight-current check-on-click-node style="padding: 10px 0;">
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                        <span>{{ node.label }}</span>
                        <span v-if="adminSearch.depart_id == data.id && data.id > 0">
                            <el-popover placement="right" width="100" trigger="hover">
                                <div>
                                    <div style="cursor: pointer;margin-bottom: 10px;" v-permit="'/admin/department/edit'" @click="() => departEdit(data, '修改部门')">修改</div>
                                    <div style="cursor: pointer;margin-bottom: 10px;" v-permit="'/admin/department/add'" @click="() => departAdd(data, '添加下级部门')">添加下级</div>
                                    <div style="cursor: pointer;" v-permit="'/admin/department/del'" @click="() => departDel(data)">删除</div>
                                </div>
                                <i class="el-icon-s-tools" style="font-size: 18px;" slot="reference"></i>
                            </el-popover>
                        </span>
                    </span>
                </el-tree>
                </el-scrollbar>
			</div>
			<div class="right" style="width: calc(100% - 200px - 50px);">
				<el-table :data="list" height="70vh" stripe :header-cell-style="{ background:'#f5f5f5'}">
				    <el-table-column prop="admin_id" label="ID" width="80"></el-table-column>
				    <el-table-column prop="nick_name" label="姓名" ></el-table-column>
                    <el-table-column prop="phone" label="手机号" width="150"></el-table-column>
                    <el-table-column prop="group_name" label="职务" ></el-table-column>
				    <el-table-column prop="depart_name" label="部门" min-width="180"></el-table-column>
				    <el-table-column prop="is_leader_text" label="负责人" width="100"></el-table-column>
				    <el-table-column prop="tag_text" label="标签" ></el-table-column>
				    <el-table-column prop="state_text" label="状态" width="100"></el-table-column>
				    <el-table-column label="操作" width="200px">
                        <template slot-scope="scope">
                            <div class="_flex">
                                <el-button size="mini" type="primary" v-permit="'/admin/admin/edit'" @click="getAdminDetail(scope.row.admin_id)">编辑</el-button>
                                <el-button size="mini" type="warning" v-permit="'/admin/admin/disable'" v-if="scope.row.state == 1" @click="setAdminState(scope.row.admin_id)">禁用</el-button>
                                <el-button size="mini" v-permit="'/admin/admin/disable'" v-if="scope.row.state == 2" @click="setAdminState(scope.row.admin_id)">启用</el-button>
                                <el-button size="mini" type="danger" v-permit="'/admin/admin/del'" @click="delAdmin(scope.row.admin_id)">删除</el-button>
                            </div>
                        </template>
				    </el-table-column>
				  </el-table>
			</div>
		</div>
		
		<el-dialog :title="departForm.title" :visible="show" width="500px" center @close="show=false">
		  <el-form label-position="right" label-width="100px" :model="departForm" class="pr_20">
		    <el-form-item label="直接上级：">
                <el-cascader v-model="departForm.pid" clearable :options="departArr" :props="{value:'id',label:'name',checkStrictly:true}" :show-all-levels="false"></el-cascader>
		    </el-form-item>
		    <el-form-item label="组织名称：">
		      <el-input v-model="departForm.name" clearable placeholder="请输入"></el-input>
		    </el-form-item>
		    <el-form-item label="排序：">
		      <el-input v-model="departForm.sort" clearable placeholder="越大越靠前"></el-input>
		    </el-form-item>
		    <el-form-item label="部门ID：">
				{{departForm.id ? departForm.id : ''}}
		    </el-form-item>
		  </el-form>
            <span slot="footer">
                <el-button type="" @click="show = false">取 消</el-button>
                <el-button type="primary" @click="departSubmit">确 定</el-button>
            </span>
		</el-dialog>
		
		<el-dialog title="员工信息" :visible="represShow" width="800px" center destroy-on-close @close="represShow=false" :loading="loading">
            <el-scrollbar style="height: 60vh;">
                <el-form label-position="right" label-width="100px" ref="ruleForm" :rules="rules" :model="adminForm" class="pr_20">
                    <el-row :gutter="30">
                        <el-col :span="12">
                            <el-form-item label="头像：" prop="avatar">
                                <multiUpload :type='0' :limitImg='1' :noneBtnImg='avatarList.length > 0' :fileList="avatarList" @saveImg="saveImg" @delImg="delImg" />
                            </el-form-item>
                            <el-form-item label="账号：" prop="phone">
                                <el-input v-model="adminForm.phone"></el-input>
                                <div class="h20 f_12">  <span class="red mr_10" @click="resetpass" style="cursor: pointer;">重置密码</span>默认:abc123456</div>
                                <div class="h20 f_12"> <span class="red mr_10" @click="resetlogin" style="cursor: pointer;">重置登录状态</span>迫使账号重新登录</div>
                            </el-form-item>
                            <el-form-item label="姓名："  prop="nick_name">
                            <el-input v-model="adminForm.nick_name"></el-input>
                            </el-form-item>
                            <el-form-item label="性别："  prop="gender">
                            <el-radio-group v-model="adminForm.gender">
                                <el-radio :label="1">男</el-radio>
                                <el-radio :label="2">女</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="出生：" prop="birthday">
                            <el-date-picker v-model="adminForm.birthday" type="date" value-format="yyyy-MM-dd" style="width: 100%;" placeholder="选择日期"/>
                            </el-form-item>
                            <el-form-item label="入职：" prop="entryday">
                            <el-date-picker v-model="adminForm.entryday" type="date" value-format="yyyy-MM-dd" style="width: 100%;" placeholder="选择日期"/>
                            </el-form-item>
                            <el-form-item label="毕业：" prop="graduate">
                            <el-input v-model="adminForm.graduate"></el-input>
                            </el-form-item>
                            <el-form-item label="住址：" prop="address">
                            <el-input v-model="adminForm.address"></el-input>
                            </el-form-item>
                            <el-form-item label="紧急联系：" prop="emergency">
                            <el-input v-model="adminForm.emergency"></el-input>
                            </el-form-item>
                        </el-col>
                        <div class="br1se" style="position: absolute;height: 100%;left: 50%;"></div>
                        <el-col :span="12">
                            <el-form-item label="所属部门：" prop="depart_id">
                                <el-cascader v-model="adminForm.depart_id" :options="departArr" :props="{value:'id',label:'name',checkStrictly:true}" style="width: 100%;"></el-cascader>
                            </el-form-item>
                            <el-form-item label="负责人："  prop="is_leader">
                                <el-radio-group v-model="adminForm.is_leader">
                                    <el-radio :label="1">是</el-radio>
                                    <el-radio :label="0">否</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item label="岗位角色："  prop="group_id">
                            <el-select v-model="adminForm.group_id" class="w_100" placeholder="请选择">
                                <el-option v-for="(item,index) in roleArr" :key="index" :label="item.group_name" :value="item.group_id"> </el-option>
                                </el-select>
                            </el-form-item>
                            <CustomFormItem :form="adminForm" :item="item" v-for="item in fieldArr" :key="item.name" v-if="!['id', 'state'].includes(item.name)" />
                        </el-col>
                    </el-row>
                </el-form>
            </el-scrollbar>
          <span slot="footer">
            <el-button @click="represShow=false">取 消</el-button>
            <el-button type="primary" @click="adminSubmit('ruleForm')">确 定</el-button>
          </span>
		</el-dialog>
    </el-main>
    <el-footer class="foot" style="display: flex;align-items: center;background-color: #fff;">
        <div style="margin-left: auto;">
            <el-pagination background @size-change="changeLimit" :current-page="adminSearch.page" @current-change="changePage" :page-size="adminSearch.limit" layout="total, sizes, prev, pager, next, jumper" :total="adminSearch.total" :page-sizes="[10, 50, 100, 200, 300, 500]"></el-pagination>
        </div>
    </el-footer>
</el-container>
</template>
<script>
import Tip from "@/components/Tip/Tip.vue"
import multiUpload from "@/components/multiUpload/multiUpload.vue"
import CustomFormItem from "@/components/CustomForm/CustomFormItem.vue"
import {
    adminLists, adminDetail, adminAdd, adminEdit, adminDisable, adminDel, adminSetDefaultPassword, adminResetLogin, roleLists,
    DepartmentLists, DepartmentAdd, DepartmentEdit, DepartmentDel, fieldLists
} from "@/request/apis.js"
export default{
    components: { Tip, multiUpload, CustomFormItem },
    data(){
        return {
			name:'',
            loading: false,
            list : [],
			show : false,
			represShow : false,
            roleArr: [],
            adminFormInit: {},
			adminForm : {
				nick_name : '',
                phone: '',
                group_id: '',
                depart_id: '',
                avatar: '',
                gender: '',
                birthday: '',
                entryday: '',
                graduate: '',
                address: '',
                emergency: '',
                is_leader: 0,
                tag: [],
			},
            rules: {
                phone: [ { required: true, message: '请输入账号', trigger: 'blur' }, ],
                nick_name: [ { required: true, message: '请输入姓名', trigger: 'blur' }, ],
                gender: [ { required: true, message: '请选择性别', trigger: 'blur' }, ],
                entryday: [ { required: true, message: '请选择入职时间', trigger: 'blur' }, ],
                depart_id: [ { required: true, message: '请选择部门', trigger: 'blur' }, ],
                group_id: [ { required: true, message: '请选择角色', trigger: 'blur' }, ],
            },
            avatarList: [],
            adminSearch: {
                nick_name: '',
                phone: '',
                page: 1,
                limit: 10,
                total: 0,
                depart_id: 0,
            },
            departFormInit: {},
            departForm: {
                title: '创建部门',
                id: '',
                pid: [],
                name: '',
                sort: 50,
            },
			departArr:[],
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            deparToptArr: [],
            tagArr: [],
            fieldArr: [],
            defaultExpandedKeys: [],
        }
    },
	mounted() {
        this.departFormInit = {...this.departForm};
        this.adminFormInit = {...this.adminForm};
		this.getDepartmentLists();
        this.getAdminLists();
	},
	methods:{
        async getAdminLists(page = 0){
            this.adminSearch.page = page ? page : this.adminSearch.page;
            this.loading = true;
            var res = await adminLists(this.adminSearch);
            this.loading = false;
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.list = res.data;
            this.adminSearch.total = res.count;
            this.tagArr = res.other.tag;
        },
        changeLimit(limit){
            this.adminSearch.limit = limit;
            this.getAdminLists(1);
        },
        changePage(page){
            this.getAdminLists(page);
        },
        async getRoleLists(){
            var res = await roleLists();
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.roleArr = res.data;
        },
        async handleAdminAdd(){
            await this.getFieldArr();
            this.adminForm = {...this.adminFormInit};
            this.avatarList = [];
            this.getRoleLists();
            this.represShow = true;
            console.log('handleAdminAdd', this.adminForm, this.avatarList)
        },
        async getAdminDetail(admin_id){
            await this.getFieldArr();
            var res = await adminDetail({admin_id});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.adminForm = {...this.adminForm, ...res.data};
            this.avatarList = this.adminForm.avatar ? [{url: this.adminForm.avatar}] : [];
            this.getRoleLists();
            this.represShow = true;
        },
        saveImg(arr) {
            this.adminForm.avatar = arr[0];
        },
        delImg(arr) {
            this.adminForm.avatar = '';
            this.avatarList = []
        },
        adminSubmit(formName) {
            this.$refs[formName].validate(async (valid) => {
                if (!valid) {
                    return false;
                }
                let res;
                let depart_id = this.adminForm.depart_id;
                if (depart_id instanceof Array) {
                    depart_id = depart_id.length > 0 ? depart_id[depart_id.length - 1] : 0;
                }
                let params = {...this.adminForm, depart_id}
                if(this.adminForm.admin_id){
                    res = await adminEdit(params);
                }else{
                    res = await adminAdd(params);
                }
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.$message.success(res.msg);
                this.represShow = false;
                this.getAdminLists();
            });
        },
        async setAdminState(admin_id){
            var res = await adminDisable({admin_id});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg);
            this.getAdminLists();
        },
        async delAdmin(admin_id){
            this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let res = await adminDel({admin_id});
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.$message.success(res.msg || '删除成功');
                this.getAdminLists();
            }).catch(() => {});
        },
        resetpass(){
            if(!this.adminForm.admin_id){
                return;
            }
            this.$confirm('此操作将重置登录密码为abc123456, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let res = await adminSetDefaultPassword({admin_id: this.adminForm.admin_id});
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.$message.success(res.msg);
            }).catch(() => {});
        },
        resetlogin(){
            if(!this.adminForm.admin_id){
                return;
            }
            this.$confirm('此操作将重置登录状态,迫使涨号重新登录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let res = await adminResetLogin({admin_id: this.adminForm.admin_id});
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.$message.success('操作成功');
            }).catch(() => {});
        },
        async getDepartmentLists(){
            var res = await DepartmentLists({top: 1});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.deparToptArr = res.data;
            this.departArr = res.data[0]['children'] || [];
        },
        selectDepart(data){
            this.adminSearch.depart_id = data.id;
            this.getAdminLists(1);
        },
        async departEdit(data, title = ''){
            this.departForm = {...data, pid: data.pid_arr, title};
            this.show = true;
        },
        async departAdd(data = {}, title = ''){
            this.departForm = {...this.departFormInit, title};
            if(data.id){
                this.departForm.pid = [...data.pid_arr, data.id];
            }
            this.show = true;
            console.log('departadd', data, this.departForm)
        },
        async departSubmit(){
            let arr = this.departForm.pid;
            let params = {...this.departForm, pid: arr.length > 0 ? arr[arr.length - 1] : 0};
            let res;
            if(this.departForm.id){
                res = await DepartmentEdit(params);
            }else{
                res = await DepartmentAdd(params);
            }
            console.log('departSubmit', res);
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.$message.success(res.msg || '保存成功！');
            this.show = false;
            this.getDepartmentLists();
        },
        async departDel(data){
            this.$confirm('此操作将永久删除该部门, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                let res = await DepartmentDel({id: data.id});
                if (res.code != 0) {
                    return this.$message.error(res.msg);
                }
                this.$message.success(res.msg || '删除成功');
                this.getDepartmentLists();
            }).catch(() => {});
        },
        async getFieldArr(){
            let res = await fieldLists({table: 'admin', filter: 'customize'});
            if(res.code !== 0){
                return this.$message.error(res.msg);
            }
            this.fieldArr = res.data;
        },

        // 获取需要展开的节点 ID
        getExpandedNodeIds(nodes, level = 1, maxLevel = 3) {
            let ids = [];
            
            if (level <= maxLevel && nodes) {
                nodes.forEach(node => {
                    // 只展开前三级，第三级不展开子节点
                    if (level < maxLevel) {
                        ids.push(node.id);
                    }
                    
                    if (node.children && node.children.length > 0 && level < maxLevel) {
                        ids = ids.concat(this.getExpandedNodeIds(node.children, level + 1, maxLevel));
                    }
                });
            }
            
            return ids;
        },
        
        async getDepartmentLists(){
            var res = await DepartmentLists({top: 1});
            if (res.code != 0) {
                return this.$message.error(res.msg);
            }
            this.deparToptArr = res.data;
            this.departArr = res.data[0]['children'] || [];
            
            // 获取前三级需要展开的节点
            this.defaultExpandedKeys = this.getExpandedNodeIds(this.deparToptArr);
        },
	}
}
</script>

<style  scoped>
.custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
}
/deep/.el-tree-node__content{ height: 30px !important; }
/deep/.el-scrollbar .el-scrollbar__wrap { overflow-x: hidden; }
</style> 